import { render, staticRenderFns } from "./Kaffee.vue?vue&type=template&id=20393a29&scoped=true"
import script from "./Kaffee.vue?vue&type=script&lang=js"
export * from "./Kaffee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20393a29",
  null
  
)

export default component.exports